import { BaseState } from './base.state';
import { AuthResponse } from '../../models/auth.model';
import { ErrorResponse } from '../../models/error.model';

export interface BaseAuthState extends BaseState {
  result: {
    isAuthenticated: boolean;
    response: AuthResponse | null;
    errorResponse: ErrorResponse | null;
    storeTerminated: boolean;
  };
}

export const initialAuthState: BaseAuthState = {
  result: {
    isAuthenticated: false,
    response: null,
    errorResponse: new ErrorResponse(),
    storeTerminated: false
  }
};
